// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"761":"307ebde4","769":"7d41e268","827":"e9f6c7bc","879":"74a7e754"}[chunkId] + ".css";
};